import React, { FC } from 'react';
import APIRequest from '../../components/helpers/APIRequest';
import * as mobilbase from '../../api/mobilbase';
import { DeviceOverview } from '../../api/mobilbase/models';

//convert to hook if reused --delete this comment
interface APIRequestDeviceOverviewDataProps {
  run: boolean;
  setRun: React.Dispatch<React.SetStateAction<boolean>>;
  isPending: boolean;
  setIsPending: React.Dispatch<React.SetStateAction<boolean>>;
  selectedLocationId: number;
  setData: React.Dispatch<React.SetStateAction<DeviceOverview>>;
}

const APIRequestDeviceOverview: FC<APIRequestDeviceOverviewDataProps> = ({
  run,
  setRun,
  isPending,
  setIsPending,
  selectedLocationId,
  setData,
}) => {
  return (
    <APIRequest<DeviceOverview>
      run={run}
      setRun={setRun}
      pending={isPending}
      setIsPending={setIsPending}
      req={() => mobilbase.getDeviceOverview({ locationId: selectedLocationId })}
      setData={setData}
    />
  );
};

export default APIRequestDeviceOverview;